import Link from 'next/link'

import { Button } from '@wartek-id/button'

const TOPIC_URL = '/pelatihan-mandiri/daftar-topik'

type InfoBoxProps = {
  isShowButton?: boolean
  isError?: boolean
  title?: string
  description?: string
}

const InfoBox = ({
  isShowButton = true,
  title = 'Belum ada topik yang anda pelajari',
  description = 'Cobalah temukan di halaman daftar topik',
  isError = false,
}: InfoBoxProps) => {
  const image = isError
    ? 'https://storage.googleapis.com/microlearning-public-production/web-assets/img-error-fixing.png'
    : 'https://storage.googleapis.com/microlearning-public-production/web-assets/img-magnifying-document.png'

  return (
    <div className="bg-white border rounded-md p-4 border-gray-30">
      <img src={image} alt="empty-topic" width={48} height={48} />
      <div className="font-semibold text-lg">{title}</div>
      <div className="text-sm text-gray-60">{description}</div>
      {isShowButton && (
        <Link href={TOPIC_URL} passHref>
          <Button className="mt-4" fullWidth color="black">
            Lihat daftar topik
          </Button>
        </Link>
      )}
    </div>
  )
}

export default InfoBox
